import clsx from 'clsx'
import React from 'react'
import { Control, Controller } from 'react-hook-form'
import { useIntl } from 'react-intl'

import s from './styles.module.scss'

import TooltipButton from '../tooltip-button/TooltipButton'
import { ISelectProposalForm } from '../../modal-select-proposal.types'
import { DepartureEnum } from '../../../../../lib/graphql'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { TooltipProps } from '../../../../atoms'

interface ModalSelectProposalDepartureButtonGroupProps {
  control: Control<ISelectProposalForm, any>
  orderedDepartures: {
    value: DepartureEnum
    disabled?: boolean
    tooltipsProps?: Pick<TooltipProps, 'content' | 'position'>
  }[]
  isMobile?: true
}

const translateDeparture = ({
  departure,
}: {
  departure: DepartureEnum
}): string => {
  const intl = useIntl()

  switch (departure) {
    case DepartureEnum.MORNING:
      return intl.formatMessage({
        id: 'ui.ArrivalDepartureToggleButton.morning',
        defaultMessage: 'Matin',
      })
    case DepartureEnum.AFTER_LUNCH:
      return intl.formatMessage({
        id: 'ui.ArrivalDepartureToggleButton.afterLunch',
        defaultMessage: 'Après déjeuner',
      })
    case DepartureEnum.EVENING:
      return intl.formatMessage({
        id: 'ui.ArrivalDepartureToggleButton.evening',
        defaultMessage: 'Soir',
      })
    default:
      return intl.formatMessage({
        id: 'ui.DepartureToggleButton.default',
        defaultMessage: 'Horaire de départ inconnue',
      })
  }
}

const ModalSelectProposalDepartureButtonGroup = ({
  control,
  orderedDepartures,
  isMobile,
}: ModalSelectProposalDepartureButtonGroupProps) => {
  return (
    <Controller
      control={control}
      name='departure'
      render={({ field }) => {
        return (
          <div
            className={clsx(s.buttonGroup, { [s.buttonGroupMobile]: isMobile })}
          >
            {orderedDepartures.map((departureOptions) => {
              if (
                departureOptions.disabled &&
                field.value === departureOptions.value
              ) {
                field.onChange(
                  orderedDepartures.find((departure) => !departure.disabled)
                    ?.value,
                )
              }

              const label = translateDeparture({
                departure: departureOptions.value,
              })

              return (
                <TooltipButton
                  isDisabled={departureOptions.disabled ?? false}
                  key={departureOptions.value}
                  label={label}
                  isSelected={departureOptions.value === field.value}
                  onClick={() => {
                    Mixpanel.track('Toggle Départ', {
                      value: label,
                      data: { name: 'departure' },
                    })
                    field.onChange(departureOptions.value)
                  }}
                  {...(departureOptions.tooltipsProps &&
                    departureOptions.disabled && {
                      tooltipProps: departureOptions.tooltipsProps,
                    })}
                />
              )
            })}
          </div>
        )
      }}
    />
  )
}

export default ModalSelectProposalDepartureButtonGroup
